import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=42a36c4f&scoped=true&"
import script from "./TaskTable.vue?vue&type=script&lang=ts&"
export * from "./TaskTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a36c4f",
  null
  
)

export default component.exports